var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-member"},[(_vm.webId != null)?_c('div',[_c('h6',[_vm._v(_vm._s(_vm.member))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }